export const NewClients = {
  en: {
    'New Clients': 'New Clients',
    Name: 'Name',
    Birthday: 'Birthday',
    'Date and time of creation': 'Date and time of creation',
    Phone: 'Phone',
    Email: 'Email',
    'Check Data': 'Check Data',
  },
  uk: {
    'New Clients': 'Нові Клієнти',
    Name: "Ім'я",
    Birthday: 'Дата народження',
    'Date and time of creation': 'Дата і час створення',
    Phone: 'Телефон',
    Email: 'Пошта',
    'Check Data': 'Перевірити дані',
  },
};

export const NewClientForm = {
  en: {
    ...NewClients.en,
    'New Client': 'New Client',
    confirm: 'Confirm',
    reject: 'Reject',
    'First name': 'First Name',
    'Last name': 'Last Name',
    'Middle name': 'Middle Name',
    edit: 'Edit',
    'print eng form': 'Print ENG Form',
    'print uk form': 'Print UK Form',
    Save: 'Save',
    Cancel: 'Cancel',
    'Are you sure you want to confirm this client?':
      'Are you sure you want to confirm this client?',
    'Are you sure you want to reject this client?':
      'Are you sure you want to reject this client?',
    Orders: 'Orders',
    'Booked for': 'for',
    'Client has bookings or orders': 'The client has bookings or orders',
  },
  uk: {
    ...NewClients.uk,
    'New Client': 'Новий Клієнт',
    confirm: 'Підтвердити',
    reject: 'Відхилити',
    'First name': "Ім'я",
    'Last name': 'Прізвище',
    'Middle name': 'По батькові',
    edit: 'Редагувати',
    'print eng form': 'Анкета ENG',
    'print uk form': 'Анкета УКР',
    Save: 'Зберегти',
    Cancel: 'Відмінити',
    'Are you sure you want to confirm this client?':
      'Ви впевнені, що хочете підтвердити цього клієнта?',
    'Are you sure you want to reject this client?':
      'Ви впевнені, що хочете відхилити цього клієнта?',
    Orders: 'Замовлення',
    'Booked for': 'на',
    'Client has bookings or orders': 'У клієнта є бронювання або замовлення',
  },
};
